import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { BarChart } from '@mui/x-charts/BarChart';
import { useTheme } from '@mui/material/styles';

export default function PageViewsBarChart({ title, charges = [], discharges = [], tickInterval = 3, showChip = false }) {
  const theme = useTheme();
  const colorPalette = [
    (theme.vars || theme).palette.primary.dark,
    (theme.vars || theme).palette.primary.main,
    (theme.vars || theme).palette.primary.light,
  ];

  const total = [];
  for (let i = 0; i < charges.length; i++) {
    const temp = charges[i].value + (discharges[i] ? discharges[i].value : 0);
    total.push(parseFloat(temp.toFixed(1)));    
  }
  const totalkWh = total.reduce((acc, cur) => acc + cur, 0) / 1000;
  return (
    <Card variant="outlined" sx={{ width: '100%' }}>
      <CardContent>
        <Typography variant="subtitle2" fontWeight="bold"  gutterBottom>
          Building Meter
        </Typography>
        <Stack sx={{ justifyContent: 'space-between' }}>
          <Stack
            direction="row"
            sx={{
              alignContent: { xs: 'center', sm: 'flex-start' },
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Typography variant="h4" component="p">
              {totalkWh.toFixed(2)} kWh
            </Typography>
            {showChip && <Chip size="small" color="error" label="-8%" />}
          </Stack>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {title}
          </Typography>
        </Stack>
        <BarChart
          borderRadius={8}
          colors={colorPalette}
          xAxis={[
            {
              scaleType: 'band',
              categoryGapRatio: 0.5,
              data: charges.map(d => d.label),
              tickInterval: (index, i) => (i + 1) % tickInterval === 0, 
            },
          ]}
          series={[
            {
              id: 'total',
              label: 'Total',
              data: total,
              stack: 'A',
            },
            {
              id: 'discharges',
              label: 'Discharges',
              data: discharges.map(d => d.value.toFixed(1)),
              stack: 'B',
            },
            {
              id: 'fromgrid',
              label: 'From Grid',
              data: charges.map(d => d.value.toFixed(1)),
              stack: 'C',
            }
          ]}
          height={250}
          margin={{ left: 50, right: 0, top: 20, bottom: 20 }}
          grid={{ horizontal: true }}
          slotProps={{
            legend: {
              hidden: true,
            },
          }}
        />
      </CardContent>
    </Card>
  );
}
